define(
	'AnchorGroup.PLPFields.Entry'
	, [
		'Facets.ItemCell.View',
		'SC.Configuration',
		'Facets.Browse.View',
		'Profile.Model',
		'jQuery'
	]
	, function (
		FacetsItemCellView,
		Configuration,
		FacetsBrowseView,
		ProfileModel,
		jQuery
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var self = this;
	
				var user = {};
				var profile_promise = jQuery.Deferred();

				ProfileModel.getPromise().done(function(result)
				{
					profile_promise.resolve(ProfileModel.getInstance());
					user.limit = self.getCustomerInventoryLimit(result.priceLevel);
				})
				.fail(function()
				{
					profile_promise.reject.apply(this, arguments);
				})
                //OLD CODE 
				// var userprofilecomponent = container.getComponent("UserProfile");
				// var user = {};
				// userprofilecomponent.getUserProfile().then(function (profile) {
				// 	user.pricelevel = profile.pricelevel;
				// 	user.limit = self.getCustomerInventoryLimit(profile.pricelevel);
				// });

				FacetsItemCellView.prototype.getContext = _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));

					var available = this.model.get('quantityavailable');
					if (user.limit < available) {
						available = user.limit;
					}
					context.custom = {
						designer: this.model.get("custitem_ppdesignerforitem"),
						category: this.model.get("class"),
						upccode: this.model.get("upccode"),
						available: available,
						isInStock: available > 0
					}

					return context;
				});

				var plp = container.getComponent('PLP');
				FacetsBrowseView.prototype.getContext = _.wrap(FacetsBrowseView.prototype.getContext, function (fn) {
					var context = fn.apply(this, _.toArray(arguments).slice(1));

					var pagination = plp.getPagination();
					var displayType = pagination.display;
					context.displayTypeIsList = displayType == "list";

					return context;
				});
			},

			getCustomerInventoryLimit: function (priceLevel) {
				var priceLevelInventoryDisplay = Configuration.get("pricelevelinventorydisplay");
				var limitObj = _.filter(priceLevelInventoryDisplay, function (item) {
					return item.pricelevel == priceLevel;
				})[0];
				var customerInventoryLimit = limitObj.maximum;
				return customerInventoryLimit;

			},
		};
	});
